import React, { useState } from "react";
import { NavLink, Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa'
import '../sass/layout/_header.scss';
import '../sass/base/_header_typo.scss';

const Header = () => {
    const [nav, setNav] = useState(false)

    const handleClick = () => {
        setNav(!nav)
    }

    return (
        <header id='heading' className='heading-page'>
            <Link to='/' className="logo">
                <h1>o a c</h1>
            </Link>
            <nav className={nav ? 'navigation active' : 'navigation'}>
                <ul>
                    <li>
                        <NavLink
                            href='../pages/About'
                            to="/about"
                            className={(nav) => (nav.isActive ? 'nav-active' : '')}
                        >
                            A propos
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            href='../pages/Price'
                            to="/tarif"
                            className={(nav) => (nav.isActive ? 'nav-active' : '')}
                        >
                            Nos Tarifs
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            href='../pages/Contact'
                            to='/contact'
                            className={(nav) => (nav.isActive ? 'nav-active' : '')}
                        >
                            Nous contacter
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            href='../pages/Realisation'
                            to="/realisation"
                            className={(nav) => (nav.isActive ? 'nav-active' : '')}
                        >
                            Nos Réalisations
                        </NavLink>
                    </li>
                </ul>
            </nav>
            <div className='toggle' onClick={handleClick}>
                {nav ? (<FaTimes size={20} style={{ color: '#333' }} />) : (<FaBars size={20} style={{ color: '#333' }} />)}
            </div>
        </header>
    )
}

export default Header;